import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const TestimonialSection = () => {
  const [testimonial, setTestimonial] = useState([]);

  const [testimonialtext, setTestimonialText] = useState([]);
  const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  const [page, setPage] = useState([]);

  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
      .then((res) => res.json())
      .then((info) => setPage(info))
      .catch((error) => console.error("Error fetching banners:", error));
  }, []);

  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/testimonialtext`)
      .then((res) => res.json())
      .then((info) => setTestimonialText(info));
  }, []);

  useEffect(() => {
    fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/testimonials`)
      .then((res) => res.json())
      .then((info) => setTestimonial(info));
  }, []);


  const divStyle = {
    backgroundImage: "url(img/testimonial/test-bg-aliments.png)",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundColor: "#fff7f5",
  };

  return (


    <><section id="reviews-3" className="reviews-3 wide-100 reviews-section division">
    <div className="container">
      {/* SECTION TITLE */}
      <div className="row">
        <div className="col-lg-10 offset-lg-1">
          {
            testimonialtext.map(e => e.pageSlug === page.pageSlug && <div className="section-title mb-50">
              {/* Title 	*/}
              <h3 className="h3-md">{e.testimonialHeading}</h3>
              {/* Text */}
              <p className="p-lg">{e.testimonialText}
              </p>
            </div>)}
        </div>
      </div>
      {/* TESTIMONIALS CONTENT */}
      <div className="row">
        <div className="col-sm-1 col-md-12">
          <div className="owl-carousel owl-theme reviews-wrapper d-flex">
            {testimonial.map(
              (b) =>
                b.pageSlug === page.pageSlug && (
                  <div className="review-3 d-flex flex-column align-items-center text-center">
                    {/* App Rating */}
                    <div className="app-rating yellow-color">
                      <i className="fas fa-star" />
                      <i className="fas fa-star" />
                      <i className="fas fa-star" />
                      <i className="fas fa-star" />
                      <i className="fas fa-star-half-alt" />
                    </div>
                    {/* Avatar */}
                    <div>
                      <img
                        src={b.image}
                        alt="testimonial-avatar"
                        className="img-fluid rounded-circle"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                    {/* Testimonial Text */}
                    <div className="review-3-txt">
                      <p>{b.desc}</p>
                      <h6 className="h6-xs">{b.personName}</h6>
                      <span>{b.personTitle}</span>
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      </div>
    </div>
  </section></>


  );
};

export default TestimonialSection;
